import { LCDClient } from "@osmonauts/lcd";
export class LCDQueryClient extends LCDClient {
  constructor({
    restEndpoint
  }) {
    super({
      restEndpoint
    });
  }
  /* Pools */


  async pools(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") {
      options.params.pagination = params.pagination;
    }

    const endpoint = `osmosis/gamm/v1beta1/pools`;
    return await this.request(endpoint, options);
  }
  /* NumPools */


  async numPools(params) {
    const endpoint = `osmosis/gamm/v1beta1/num_pools`;
    return await this.request(endpoint);
  }
  /* TotalLiquidity */


  async totalLiquidity(params) {
    const endpoint = `osmosis/gamm/v1beta1/total_liquidity`;
    return await this.request(endpoint);
  }
  /* Per Pool gRPC Endpoints */


  async pool(params) {
    const endpoint = `osmosis/gamm/v1beta1/pools/${params.poolId}`;
    return await this.request(endpoint);
  }
  /* PoolParams */


  async poolParams(params) {
    const endpoint = `osmosis/gamm/v1beta1/pools/${params.poolId}/params`;
    return await this.request(endpoint);
  }
  /* TotalPoolLiquidity */


  async totalPoolLiquidity(params) {
    const endpoint = `osmosis/gamm/v1beta1/pools/${params.poolId}/total_pool_liquidity`;
    return await this.request(endpoint);
  }
  /* TotalShares */


  async totalShares(params) {
    const endpoint = `osmosis/gamm/v1beta1/pools/${params.poolId}/total_shares`;
    return await this.request(endpoint);
  }
  /* SpotPrice defines a gRPC query handler that returns the spot price given
  a base denomination and a quote denomination. */


  async spotPrice(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.baseAssetDenom) !== "undefined") {
      options.params.base_asset_denom = params.baseAssetDenom;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.quoteAssetDenom) !== "undefined") {
      options.params.quote_asset_denom = params.quoteAssetDenom;
    }

    const endpoint = `osmosis/gamm/v1beta1/pools/${params.poolId}/prices`;
    return await this.request(endpoint, options);
  }
  /* Estimate the swap. */


  async estimateSwapExactAmountIn(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.sender) !== "undefined") {
      options.params.sender = params.sender;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.tokenIn) !== "undefined") {
      options.params.token_in = params.tokenIn;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.routes) !== "undefined") {
      options.params.routes = params.routes;
    }

    const endpoint = `osmosis/gamm/v1beta1/${params.poolId}/estimate/swap_exact_amount_in`;
    return await this.request(endpoint, options);
  }
  /* EstimateSwapExactAmountOut */


  async estimateSwapExactAmountOut(params) {
    const options = {
      params: {}
    };

    if (typeof (params === null || params === void 0 ? void 0 : params.sender) !== "undefined") {
      options.params.sender = params.sender;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.routes) !== "undefined") {
      options.params.routes = params.routes;
    }

    if (typeof (params === null || params === void 0 ? void 0 : params.tokenOut) !== "undefined") {
      options.params.token_out = params.tokenOut;
    }

    const endpoint = `osmosis/gamm/v1beta1/${params.poolId}/estimate/swap_exact_amount_out`;
    return await this.request(endpoint, options);
  }

}